const WarehouseSVG = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 595.28 595.28">
            <path d="M585.65 266.22 298.39 49 11.14 266.22l21.11 27.92 35.99-27.21v260.81h254.83V427h-67.35v-65.74h-67.35v-30.11h220.07v196.6h120.13V266.94l35.99 27.21 21.11-27.92ZM220.71 492.74h-32.35V462h32.35v30.74Zm67.35-30.75v30.74h-32.35v-30.74h32.35Zm-67.35-65.74v30.74h-32.35v-30.74h32.35Zm272.85 96.49h-50.13v-196.6H153.36v196.6h-50.13V240.46L298.39 92.88l195.16 147.58v252.28Z"/>
        </svg>    )
};

export default WarehouseSVG;